import toast from 'react-hot-toast';
import useApi from '../useApi';
import {StopTimerRequest,StopTimerResponse} from "./index.type";


const useStopTimerAutomatic = ({ patientId,clinicId }: { patientId: string,clinicId:string  }) => {
    const url= `/rtm/timer/end?associatedClinicianId=${clinicId}&patientId=${patientId}` 
   
  const method = 'POST'; 
  const { loading: StopTimerLoading , makeApiCall } = useApi({ url, method });

  const StopTimer = async (formData: StopTimerRequest): Promise<StopTimerResponse | { status: "fail" }> => {
    const { response, error } = await makeApiCall< StopTimerRequest , StopTimerResponse>(formData);
    if (response?.status === 'success') {
   
      toast.success('Timer stopped successfully');

      return response;
    }

    if (error || !response?.status) {
      toast.error(error?.msg || 'Failed to stop timer. Please try again.');
    }
    return { status: 'fail' };
  };

  return {
    StopTimerLoading,
    StopTimer,
  };
};

export default useStopTimerAutomatic ;
